import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material";
const StyledMaterialSymbol = styled("span", {
    shouldForwardProp: (prop) => prop !== "color" &&
        prop !== "fill" &&
        prop !== "fontSize" &&
        prop !== "grade" &&
        prop !== "opticalSize",
})(({ theme, color, fill, fontSize, grade, opticalSize }) => ({
    color: theme.palette[color].main,
    "&.material-symbols-rounded": {
        fontSize,
        fontVariationSettings: `'FILL' ${fill}, 'wght' 400, 'GRAD' ${grade}, 'opsz' ${opticalSize}`,
    },
}));
// tests covered by Icon.spec.tsx
const StyledMaterialSymbolIcon = ({ children, color, fill = "0", fontSize, testId, }) => {
    const iconSizes = {
        extraSmall: "0.75rem",
        small: "1.125rem",
        medium: "1.25rem",
        large: "1.5rem",
        extraLarge: "3rem",
    };
    const opticalSizes = {
        extraSmall: "20",
        small: "20",
        medium: "20",
        large: "24",
        extraLarge: "48",
    };
    return (_jsx(StyledMaterialSymbol, Object.assign({ className: "material-symbols-rounded", color: color, fill: fill, fontSize: iconSizes[fontSize], grade: fontSize === "extraSmall" ? "200" : "0", opticalSize: opticalSizes[fontSize], "data-testid": testId }, { children: children })));
};
export default StyledMaterialSymbolIcon;
